if (!customElements.get('mv-quantity-presets')) {
  customElements.define('mv-quantity-presets', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.product = this.closest('product-info');
      this.quantity = this.parentElement.querySelector('input[name="quantity"]');
      if (!this.product || !this.quantity) return;
      this.variants = JSON.parse(this.querySelector('[data-preset-variants]').textContent);
      this.addEventListener('change', event => {
        if (event.target.type !== 'radio') return;
        this.quantity.value = event.target.value;
        this.quantity.dispatchEvent(new Event('change', { bubbles: true }));
      }, { signal });
      this.quantity.addEventListener('change', () => this.refresh(), { signal });
      this.product.addEventListener('change', event => {
        if (event.target.name === 'id') this.refresh();
        if (event.target.closest('variant-selects')) {
          const button = this.product.querySelector('[data-mv-preset-buy-now]');
          if (button) button.disabled = true;
        }
      }, { signal });
      if (typeof subscribe === 'function') this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, event => {
        if (String(event.data.sectionId) === this.dataset.section) this.refresh();
      });
      this.parentElement.classList.add('mv-quantity-enhanced');
      this.refresh();
      let attempts = 0;
      const waitForCheckout = () => {
        if (!this.isConnected) return;
        const button = this.product.querySelector('[data-mv-preset-buy-now]');
        if (button?._phxBound) { this.refresh(); return; }
        if (++attempts < 100) this.checkoutTimer = setTimeout(waitForCheckout, 100);
      };
      waitForCheckout();
    }
    refresh() {
      const form = document.getElementById(this.dataset.form);
      const variant = this.variants.find(item => String(item.id) === form?.querySelector('[name="id"]')?.value);
      const buyNow = this.product.querySelector('[data-mv-preset-buy-now]');
      if (buyNow) buyNow.disabled = !buyNow._phxBound || !variant?.available || buyNow.dataset.phxBusy === '1';
      this.querySelectorAll('input[type="radio"]').forEach(input => {
        input.checked = input.value === this.quantity.value;
        const max = Number(this.quantity.max || Infinity);
        const min = Number(this.quantity.min || 1);
        input.disabled = Number(input.value) < min || Number(input.value) > max;
      });
      if (!variant) return;
      const format = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: this.dataset.currency || 'USD' });
      this.querySelectorAll('[data-preset-price]').forEach(node => {
        node.textContent = format.format(variant.price * Number(node.dataset.presetPrice) / 100);
      });
    }
    disconnectedCallback() { this.controller?.abort(); this.unsubscribe?.(); clearTimeout(this.checkoutTimer); }
  });
}
